<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="reports-btns-list">
    <button
        [routerLink]="['/', { outlets: { popup: 'project-view/constraint-compliance' } }]"
        class="btn btn-link btn-sm btn--constraint-compliance item_row"
    >
        Constraint compliance
    </button>

    <button [routerLink]="['/', { outlets: { popup: 'project-view/p2p-info' } }]" class="btn btn-link btn-sm btn--p2p-info item_row">
        PtP info
    </button>

    <button [routerLink]="['/', { outlets: { popup: 'project-view/p2mp-info' } }]" class="btn btn-link btn-sm btn--p2mp-info item_row">
        PtMP info
    </button>

    <button
        *ngIf="!projectStateService.isPotentiallyCorruptedProject() && projectHasMhTgBu()"
        [replaceUrl]="true"
        [routerLink]="['/', { outlets: { popup: 'project-view/an-ip-report' } }]"
        class="btn btn-link btn-sm btn-ad-ip-report item_row"
    >
        AN and IP info
    </button>

    <ng-container *ngIf="!projectStateService.isPotentiallyCorruptedProject() && showTunnels">
        <button
            [disabled]="!historyService.isEditModeEnabled"
            [replaceUrl]="true"
            [routerLink]="['/', { outlets: { popup: 'project-view/tunnels-report' } }]"
            class="btn btn-link btn-sm btn-design-config item_row"
        >
            Tunnels
        </button>
        <div class="form-check item_row">
            <label class="form-check-label">
                <input
                    (change)="tunnelsService.toggleAllTunnelsView()"
                    [ngModel]="tunnelsService.areAllTunnelsDisplayed"
                    class="form-check-input is-show-tunnels"
                    type="checkbox"
                />
                Show Tunnels
            </label>
        </div>
    </ng-container>

    <button (click)="exportAllReports()" class="btn btn-link btn-sm btn--export-all-reports item_row">Export reports to Excel</button>
</div>
